"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var Subject_1 = require("rxjs/Subject");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var meta_field_utils_1 = require("../../../utils/meta-field-utils");
var table_model_1 = require("../model/table.model");
var translator_pipe_1 = require("../../../pipe/translator.pipe");
var EditorBindTablePopupComponent = /** @class */ (function () {
    function EditorBindTablePopupComponent(_data, _kbService, _dialogRef, _messagePipe) {
        var _this = this;
        this._data = _data;
        this._kbService = _kbService;
        this._dialogRef = _dialogRef;
        this._messagePipe = _messagePipe;
        this._validations = new Map();
        this._showValidations = false;
        this._columnsData = [];
        this._selectedColumns = [];
        this._destroy$ = new Subject_1.Subject();
        this._onFieldIdChange$ = new Subject_1.Subject();
        this.condition = '';
        this.columnName = {};
        this._onFieldIdChange$
            .pipe(operators_1.map(function (fieldId) { return _this.getFieldCompoundSystemName(fieldId); }), operators_1.switchMap(function (categoryName) { return _this.getColumns(categoryName); }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (columns) {
            _this._selectedColumns = [];
            _this._columnsData = columns;
        });
        this.getFunctionalFields(_data.categoryName)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (items) {
            _this._functionalMetaFields = items;
            _this._selectedFunctionalField = _data.metaFieldSystemName;
            _this._onFieldIdChange$.next(_this._selectedFunctionalField);
        });
        this._categoryName = _data.categoryName;
        this._selectedColumns = _data.selectedColumns || [];
        this._isNumbering = (_data.isNumbering === 'true');
        this._isShowEmptyRow = (_data.isShowEmptyRow === 'true');
        this.condition = _data.condition || '';
    }
    EditorBindTablePopupComponent.prototype.save = function () {
        var _this = this;
        if (this.isValid()) {
            var selectedOptions = this._selectedColumns
                .map(function (columnId) {
                var column = _this._columnsData[0].items.find(function (option) { return option.value.id === columnId; });
                column['displayName'] = _this.columnName[columnId];
                return column;
            });
            this._dialogRef.close(new table_model_1.TableModel(selectedOptions, this._selectedFunctionalField, this._isNumbering, this._isShowEmptyRow, this.condition));
        }
    };
    EditorBindTablePopupComponent.prototype.close = function () {
        this._dialogRef.close();
    };
    EditorBindTablePopupComponent.prototype.onSelect = function (field) {
        this._selectedFunctionalField = field;
        this._onFieldIdChange$.next(this._selectedFunctionalField);
    };
    EditorBindTablePopupComponent.prototype.getFunctionalFields = function (categoryName) {
        return this._kbService.getMetaFields(categoryName)
            .map(function (metaFields) {
            return meta_field_utils_1.getComboBoxItems(metaFields.filter(function (metaField) { return meta_field_utils_1.isFunctionalField(metaField); }));
        });
    };
    EditorBindTablePopupComponent.prototype.getColumns = function (subEntityName) {
        var _this = this;
        return subEntityName ? this._kbService.getMetaFields(subEntityName)
            .map(function (columns) {
            _this.columnName = columns.reduce(function (obj, column) {
                obj[column.getSystemName()] = column.getDisplayNameMultilingual();
                return obj;
            }, {});
            return [meta_field_utils_1.createComboBoxOptionsGroup(columns.filter(function (metaField) { return meta_field_utils_1.isSimpleField(metaField); }), subEntityName)];
        }).flatMap(function (options) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, options[0].items
                .map(function (option) {
                return _this.translateColumnName(option);
            }));
        }).map(function (optionItems) {
            return [new idm_ng_controls_1.ComboboxGroup(optionItems, subEntityName)];
        }) : of_1.of([]);
    };
    EditorBindTablePopupComponent.prototype.translateColumnName = function (option) {
        return this._messagePipe.transform(option.name).map(function (name) {
            return Object.assign({}, option, { name: name || '' });
        });
    };
    EditorBindTablePopupComponent.prototype.getFieldCompoundSystemName = function (systemName) {
        return systemName ? this._functionalMetaFields
            .find(function (metaFieldView) { return metaFieldView['name'] === systemName; })['compoundName'] : null;
    };
    EditorBindTablePopupComponent.prototype.changeColumnsOrder = function (items) {
        this._selectedColumns = items;
    };
    EditorBindTablePopupComponent.prototype.setValues = function (values) {
        this._selectedColumns = values;
    };
    EditorBindTablePopupComponent.prototype.isValid = function () {
        this._functionalFieldErrorFlag = this._selectedFunctionalField == null || this._selectedFunctionalField === '';
        this._selectedColumnsErrorFlag = !this._selectedColumns || this._selectedColumns.length === 0;
        return !(this._functionalFieldErrorFlag || this._selectedColumnsErrorFlag);
    };
    EditorBindTablePopupComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.unsubscribe();
    };
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "validations", {
        get: function () {
            return this._validations;
        },
        set: function (value) {
            this._validations = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "showValidations", {
        get: function () {
            return this._showValidations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "selectedFunctionalField", {
        get: function () {
            return this._selectedFunctionalField;
        },
        set: function (value) {
            this._selectedFunctionalField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "isNumbering", {
        get: function () {
            return this._isNumbering;
        },
        set: function (value) {
            this._isNumbering = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "functionalMetaFields", {
        get: function () {
            return this._functionalMetaFields;
        },
        set: function (value) {
            this._functionalMetaFields = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "selectedColumns", {
        get: function () {
            return this._selectedColumns;
        },
        set: function (value) {
            this._selectedColumns = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "columnsData", {
        get: function () {
            return this._columnsData;
        },
        set: function (value) {
            this._columnsData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "isShowEmptyRow", {
        get: function () {
            return this._isShowEmptyRow;
        },
        set: function (value) {
            this._isShowEmptyRow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "functionalFieldErrorFlag", {
        get: function () {
            return this._functionalFieldErrorFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindTablePopupComponent.prototype, "selectedColumnsErrorFlag", {
        get: function () {
            return this._selectedColumnsErrorFlag;
        },
        enumerable: true,
        configurable: true
    });
    EditorBindTablePopupComponent = __decorate([
        core_1.Component({
            selector: 'sis-template-editor-bind-table-popup',
            template: require('./editor-bind-table-popup.component.html'),
            styles: [require('./editor-bind-table-popup.component.css')],
            providers: [translator_pipe_1.TranslatorPipe]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, idm_kb_service_client_js_1.KbService,
            material_1.MatDialogRef, translator_pipe_1.TranslatorPipe])
    ], EditorBindTablePopupComponent);
    return EditorBindTablePopupComponent;
}());
exports.EditorBindTablePopupComponent = EditorBindTablePopupComponent;
//# sourceMappingURL=editor-bind-table-popup.component.js.map